import { openDB } from "idb";

const DB_NAME = "sterio-field-service";
const VERSION = 1;

const dbp = openDB(DB_NAME, VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("cache")) db.createObjectStore("cache");
    if (!db.objectStoreNames.contains("reports"))
      db.createObjectStore("reports", { keyPath: "id" });
  },
});

export async function setCache(key, value) {
  return (await dbp).put("cache", value, key);
}
export async function getCache(key) {
  return (await dbp).get("cache", key);
}

export async function putReport(report) {
  return (await dbp).put("reports", report);
}
export async function getReportLocal(id) {
  return (await dbp).get("reports", id);
}
export async function allReports() {
  const rows = await (await dbp).getAll("reports");
  return rows.sort((a, b) =>
    (b.updated_at || "").localeCompare(a.updated_at || "")
  );
}
export async function deleteReportLocal(id) {
  return (await dbp).delete("reports", id);
}
